import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useContactSection = () => {
    const [contactSectionData, setContactSectionData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContactSectionData = async () => {
            try {
                const query = `*[_type == "contactSection"][0] {
                    title,
                    description
                }`;

                const data = await client.fetch(query);
                setContactSectionData(data);
                setIsLoading(false);
            } catch (err) {
                setError(err);
                setIsLoading(false);
            }
        };

        fetchContactSectionData();
    }, []);

    return { contactSectionData, isLoading, error };
}; 